import React from "react";
import "./HeroSection.css";
import Button from "../Button/Button";
import { Slide } from "react-awesome-reveal";

export default function HeroSection({
  heroTitle,
  heroParagraph,
  btnLink,
  btnText,
  heroImage,
}) {
  return (
    <div
      className="Hero_Section"
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className="dark_layer"></div>
      <div className="blue_layer"></div>
      <div className="container">
        <Slide direction="down" duration={1500} delay={500} triggerOnce={true}>
          <h1>{heroTitle}</h1>
        </Slide>
        <Slide direction="down" duration={1500} delay={500} triggerOnce={true}>
          <p>{heroParagraph}</p>
        </Slide>
        <Slide direction="left" duration={1500} delay={500} triggerOnce={true}>
          <Button btnLink={btnLink} btnText={btnText} />
        </Slide>
      </div>
    </div>
  );
}
